import React from "react";
import { useTranslation } from "react-i18next";
import MonthCalendarPicker from "features/home/components/MonthCalendarPicker";
import { useChooseAnotherDate } from "../hooks/useChooseAnotherDate";
import { CalendarRange } from "lucide-react";
import styles from "./ChooseAnotherDate.module.css";

interface ChooseAnotherDateProps {
  selectedDate: any;
  setSelectedDate: any;
}

const ChooseAnotherDate = ({
  selectedDate,
  setSelectedDate,
}: ChooseAnotherDateProps) => {
  const { t } = useTranslation();

  const { open, openCalendarModal, handleDateChange, handleClose } =
    useChooseAnotherDate({
      selectedDate,
      setSelectedDate,
    });

  return (
    <>
      <div className={styles["top-space"]}>
        <p className="change-date" onClick={openCalendarModal}>
          <CalendarRange /> {t("homepage.changeDate")}
        </p>
      </div>

      <div className={styles["extra-space"]}></div>

      <MonthCalendarPicker
        open={open}
        onClose={handleClose}
        onDateSelect={handleDateChange}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
      />
    </>
  );
};

export default ChooseAnotherDate;
